import SplitLine from './split.vue';
export default SplitLine;



// WEBPACK FOOTER //
// ./src/components/k-split/index.js